import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { BillLineDescriptionEvent } from './bill-line-description-events';

@Injectable({ providedIn: 'root' })
export class BillLineDescriptionEventProvider extends DomainEventProvider<BillLineDescriptionEvent> {}
